// extracted by mini-css-extract-plugin
export var primitiveLabel = "_up-0";